import OrderService from 'services/OrderService';

import { pivot } from 'utils';

import dateformat from 'dateformat';

const _formatDate = function(timestamp = NaN, format = "UTC:yyyy-mm-dd'T'HH:MM:ss:l") {
  const date = new Date(timestamp);

  const formattedDate = window.isNaN(date.getTime()) ? null : dateformat(date, format);
  return formattedDate;
};

const _defaultTransformer = function(data) {
  return data.map((row) => ({ date: _formatDate(row.Date), price: row.Price, aggrVol: row.AggrVol }));
};

const _formatCleared = (data) => {
  if ('boolean' === typeof data) {
    return data.toString();
  }

  return '';
};

const _transformers = {
  'ord-disp-clob': function(data) {
    return data.map((row) => ({
      lOrders: row.LOrders,
      rOrders: row.ROrders,
      bidPrice: row.BidPrice,
      aggrBidVol: row.AggrBidVol,
      askPrice: row.AskPrice,
      aggrAskVol: row.AggrAskVol
    }));
  },

  'ord-disp-voice': function(data) {
    return data.map((row) => ({
      date: _formatDate(row.Date),
      orders: row.Orders,
      bidPrice: row.BidPrice,
      bidCurrency: row.BidCurrency,
      bidVol: row.BidVol,
      askPrice: row.AskPrice,
      askVol: row.AskVol,
      askCurrency: row.AskCurrency
    }));
  },

  'ord-disp-rfq': _defaultTransformer,

  'ord-disp-auc': _defaultTransformer,

  'trade-disp': function(data) {
    return data.map((row) => ({
      tradeDate: _formatDate(row.TradeDate),
      price: row.Price,
      missingPrice: row.MissingPrice,
      vol: row.Vol,
      priceNot: row.PriceNot,
      publicationDate: _formatDate(row.PublicationDate),
      transactionID: row.TransactionID,
      notionalAmt: row.NotionalAmt,
      notionalCcy: row.NotionalCcy,
      flags: row.Flags.join(', '),
      status: row.Status,
      qtyMeasUnit: row.QtyMeasUnit,
      type: row.Type,
      cleared: _formatCleared(row.Cleared),
      currency: row.Currency,
      thirdCountryExecutionVenue: row.ThirdCountryExecutionVenue,
      priceCondition: row.PriceCondition,
      priceMajorCurrency: row.PriceMajorCurrency
    }));
  },

  'trade-disp-2': function(data) {
    return pivot(
      data.map((row) => ({
        tradeDate: _formatDate(row.TradeDate),
        price: row.Price,
        missingPrice: row.MissingPrice,
        vol: row.Vol,
        ccy: row.Ccy,
        priceNot: row.PriceNot,
        publicationDate: _formatDate(row.PublicationDate),
        transactionID: row.TransactionID,
        notionalAmt: row.NotionalAmt,
        notionalCcy: row.NotionalCcy,
        flags: row.Flags.join(', '),
        status: row.Status,
        qtyMeasUnit: row.QtyMeasUnit,
        qtyPerMeas: row.QtyPerMeas,
        type: row.Type,
        cleared: _formatCleared(row.Cleared),
        thirdCountryExecutionVenue: row.ThirdCountryExecutionVenue
      }))
    );
  }
};

class OrderAdapter extends OrderService {
  loadData(criteria) {
    return super.loadData(criteria).then(function(r) {
      const additionalDescription = r.AdditionalDescription || {};

      const mappedResult = {
        data: _transformers[r.ViewType](r.Data || []),

        dataType: (r.DataType || '').toLowerCase(),
        viewType: r.ViewType,
        tradingVenue: r.TradingVenue,
        assetClass: r.AssetClass,
        subAssetClass: r.SubAssetClass,
        instrumentId: r.InstrumentID,
        instrumentDesc: r.InstrumentDescription,
        //venueType: r.VenueType,
        venueMIC: r.VenueMIC,
        currency: r.Currency,
        venueLocation: r.VenueLocation,

        additionalDescription: {
          instrumentIdType: additionalDescription.InstrumentIDType,
          instrumentId: additionalDescription.InstrumentID,
          displayDate: _formatDate(additionalDescription.Date, "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'")
        }
      };

      return mappedResult;
    });
  }
}

export default new OrderAdapter();



// WEBPACK FOOTER //
// ./src/adapters/OrderAdapter.js